(async () => {

  if (!customElements.get('product-recommendations')) {

    const Swiper = (await import('swiper')).default;
    const { Autoplay, Navigation, Pagination, Scrollbar } = await import('swiper/modules');

    // Modules are now included in the Swiper constructor options
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-recommended-products]');

        this.swiperOptions = {
          modules: [Navigation, Pagination, Scrollbar, Autoplay],
          loop: false,
          autoplay: false,
          direction: 'horizontal',
          spaceBetween: 16,
          slidesPerView: 1,
          centerInsufficientSlides: true,
          breakpoints: {
            480: {
              slidesPerView: 2
            },
            768: {
              slidesPerView: 3.5
            },
            1024: {
              slidesPerView: 5
            },
            1440: {
              slidesPerView: 6
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        window.onload = () => {
          this.init();
        }
      }

      init() {
        if (this.dataset && this.dataset.url) {
          fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const source = html.querySelector('[data-recommended-products]');
            const target = this.querySelector('[data-recommended-products]');

            if (source && source.innerHTML && source.innerHTML.trim().length) {
              target.innerHTML = source.innerHTML;
            }

            // Call update method so the swiper so works
            this.swiperInstance.update();
            this.swiperInstance.navigation.update();
          })
          .catch(e => {
            console.error(e);
          });
        }
      }
    }

    window.ProductRecommendations = ProductRecommendations;
    customElements.define('product-recommendations', ProductRecommendations);
  }
})();